import * as React from "react";
import styled, { css } from "styled-components";
const Wrapper = styled.div(
  ({ theme }) => css`
    margin-bottom: ${theme.spacings.md};
    overflow: auto;
  `
);
const StyledDefList = styled.dl.attrs({ className: "deflist" })(
  ({ theme }) => css`
    &&.deflist {
      dd {
        padding-left: ${theme.spacings.md};
        display: table-cell;
      }
    }
  `
);
const GlobalProcessingView = ({ gracePeriod }) => /* @__PURE__ */ React.createElement(Wrapper, null, /* @__PURE__ */ React.createElement("h2", null, "Global Processing Rules Configuration"), /* @__PURE__ */ React.createElement("p", null, "Global Processing Rules are applied after receipt by an Input, and before processing rules applied by Message Processors."), /* @__PURE__ */ React.createElement(StyledDefList, null, /* @__PURE__ */ React.createElement("dt", null, "Future Timestamp Normalization:"), /* @__PURE__ */ React.createElement("dd", null, gracePeriod ? "Enabled" : "Disabled"), /* @__PURE__ */ React.createElement("dt", null, "Grace Period:"), /* @__PURE__ */ React.createElement("dd", null, gracePeriod)));
export default GlobalProcessingView;
